import { Avatar, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Skeleton } from 'native-base';
import React from 'react';

import { SentOrderDetailResponseNormalized } from '../../../../../store/rateManagement/selector';

export declare namespace CardItemTypes {
  export interface Props {
    item: Utils.ArrayElement<SentOrderDetailResponseNormalized['validCustomers']>;
    isLoading?: boolean;
  }
}

export const CardItem: React.FC<CardItemTypes.Props> = ({ item, isLoading }) => {
  return (
    <VStack
      shadow={1}
      marginBottom={Spacing['inset.xs']}
      borderRadius={Spacing['inline.nano']}
      width={'100%'}
      justifyContent={'space-between'}
      paddingX={Spacing['inset.sm']}
      paddingY={Spacing['inset.sm']}
      background={Color['neutral.white']}>
      {/* TO DO: loading feito sem validar layout, pois nao temos dados populados neste cenário */}
      {isLoading ? (
        <Skeleton
          marginBottom={Spacing['inline.nano']}
          testID="test-skeleton"
          borderRadius={'sm'}
          height={'30px'}
        />
      ) : (
        <HStack paddingBottom={Spacing['inset.xs']} alignItems={'center'} flex={1}>
          <Box alignItems={'center'} mr={Spacing['inset.xs']}>
            <Avatar
              testId="table-customer-suitability"
              bgColor={'linechart.principal'}
              initials={item.customerNameNormalized}
              textColor={'neutral.white'}
            />
          </Box>

          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            fontWeight={Typography['fontweight.semibold']}
            flex={1}
            textAlign="start">
            {item.customerName}
          </Text>
        </HStack>
      )}

      <HStack paddingBottom={Spacing['inset.xs']} justifyContent={'space-between'}>
        <VStack>
          <Text
            isLoading={isLoading}
            fontSize={Typography['fontsize.xs']}
            pb={Spacing['inline.nano']}>
            Conta de custódia
          </Text>
          <Text isLoading={isLoading} fontSize={Typography['fontsize.md']}>
            {item.customerCustodyAccountNormalized}
          </Text>
        </VStack>

        <VStack>
          <Text
            isLoading={isLoading}
            fontSize={Typography['fontsize.xs']}
            pb={Spacing['inline.nano']}>
            Mês movimento
          </Text>
          <Text isLoading={isLoading} fontSize={Typography['fontsize.md']}>
            {item.managementFeeMonthNormalized}
          </Text>
        </VStack>

        <VStack>
          <Text
            isLoading={isLoading}
            fontSize={Typography['fontsize.xs']}
            pb={Spacing['inline.nano']}>
            Saldo disponível
          </Text>
          <Text isLoading={isLoading} fontSize={Typography['fontsize.md']}>
            {item.customerAvailableBalanceNormalized}
          </Text>
        </VStack>
      </HStack>

      <HStack justifyContent={'space-between'}>
        <Text
          isLoading={isLoading}
          fontSize={Typography['fontsize.md']}
          pb={Spacing['inline.nano']}>
          Taxa(R$)
        </Text>
        <Text
          isLoading={isLoading}
          fontSize={Typography['fontsize.md']}
          fontWeight={Typography['fontweight.semibold']}>
          {item.managementFeeRateNormalized}
        </Text>
      </HStack>
    </VStack>
  );
};
